export const checkKeys = (key: string | number, keys: string[] | number[]) => {
    if(key && keys) {
        for(let i = 0; i < keys.length; i++) {
            if(key === keys[i]) return true;
        }
    }
    return false;
}